"use strict";

exports.__esModule = true;
var InputType;

(function (InputType) {
  InputType[InputType["INCOMPATIBLE"] = 0] = "INCOMPATIBLE";
  InputType[InputType["RGB"] = 1] = "RGB";
  InputType[InputType["HSL"] = 2] = "HSL";
  InputType[InputType["HEX"] = 3] = "HEX";
  InputType[InputType["COLOUR_CHISEL"] = 4] = "COLOUR_CHISEL";
  InputType[InputType["CODE"] = 5] = "CODE";
  InputType[InputType["ARRAY"] = 6] = "ARRAY";
})(InputType || (InputType = {}));

exports.InputType = InputType;
var hexRegExp = RegExp("^#(?:[0-9a-fA-F]{3}){1,2}$");
var rgbRegExp = /^rgb\((\d+),\s*(\d+),\s*(\d+)\)$/; // Duplicate checks are here to make reading and adding new checks easier.

function determineInput(input) {
  // null or undefined check
  if (input === undefined || input === null) {
    return InputType.INCOMPATIBLE;
  } // hex check


  if (typeof input === "string" && hexRegExp.test(input)) {
    return InputType.HEX;
  } // rgb check


  if (typeof input === "string" && rgbRegExp.test(input)) {
    return InputType.RGB;
  } // hsl check


  if (Array.isArray(input) && input.length === 3) {
    return InputType.HSL;
  } // colour chisel check


  if (input.discriminator === "isColourChisel") {
    return InputType.COLOUR_CHISEL;
  } // array


  if (Array.isArray(input)) {
    return InputType.ARRAY;
  } // code


  if (typeof input === "string") {
    return InputType.CODE;
  }

  return InputType.INCOMPATIBLE;
}

exports.determineInput = determineInput;